export default "__VITE_ASSET___ndmELJM__"